/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_Desc_3Inputs */

const et_benefits_desc_3 = /** @type {(inputs: Benefits_Desc_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kui olete kord top 3-s, püsite seal tavaliselt aastaid. Ilma igakuiste lisakuludeta.`)
};

const en_benefits_desc_3 = /** @type {(inputs: Benefits_Desc_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you reach the top 3, you typically stay there for years. Without monthly extra costs.`)
};

/**
* | output |
* | --- |
* | "Once you reach the top 3, you typically stay there for years. Without monthly extra costs." |
*
* @param {Benefits_Desc_3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_desc_3 = /** @type {((inputs?: Benefits_Desc_3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_Desc_3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_desc_3(inputs)
	return en_benefits_desc_3(inputs)
});